module.exports = __webpack_public_path__ + "img/photo4.1b7dcf4c.jpg";